<ng-template #content let-modal>
  <div class="modal-container case-type-modal" >

    <div class="modal-header">
      <div class="lookup-title">
        Case type
      </div>
      <div class="lookup-close float-end clearfix"><img (click)="close()" src="../../../../../../../assets/icons/Close.svg" alt="Close"></div>

    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col-12 status-container">
          <div class="status">
            <app-drop-down-with-icon
              [appendTo]="'body'"
              [items]="availableCaseTypes"
              [(selectedItemId)]="theCaseTypeCode"
            ></app-drop-down-with-icon>
          </div>
        </div>
        <div class="col save">
          <button
            class="save-button"
            (click)="save()"
            [disabled]="disableSave()"
            >
            {{ 'case-type-save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
